const getParameterizableQuoteFieldService = async (insurance_types = []) =>
    await fetch(`/api/parameterizableQuoteFields`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': window?.Laravel?.csrfToken || '',
        },
        body: JSON.stringify({ insurance_types }),
    })
        .then(response => {
            if (!response.ok) {
                return [];
            }
            return response.json();
        })
        .then(data => {
            if (!Array.isArray(data)) {
                return [];
            }
            return data;
        })
        .catch(error => {
            return [];
        });

export default getParameterizableQuoteFieldService;
